module.exports = __webpack_public_path__ + "img/illus_44.43c885cb.png";